import client from '../../apollo';
import customerDealerGroupQuery from '../../graphql/customerDealerGroupQuery';
import dealerListQuery from '../../graphql/dealerListQuery';
import {
  GROUP_ID_EMPTY,
  NO_GROUP_LABEL,
  DEALER_GROUP_PAGE_SIZE,
} from '../../constants/customerGroup';

const FIRST_PAGE = 1;

// The explicit "no group" option so the dealer can be unassigned from the
// dropdown (maps to the backend GROUP_ID_EMPTY marker).
export const NO_GROUP_OPTION = {
  key: GROUP_ID_EMPTY,
  text: NO_GROUP_LABEL,
  value: GROUP_ID_EMPTY,
};

// Map a backend customer group into a Semantic UI dropdown option.
export const mapGroupToOption = group => ({
  key: Number(group.groupId),
  text: group.groupName,
  value: Number(group.groupId),
});

export const fetchDealerGroupOptions = async(groupName = '') => {
  const { data } = await client.query({
    query: customerDealerGroupQuery,
    variables: { groupName, size: DEALER_GROUP_PAGE_SIZE, page: FIRST_PAGE },
  });
  const { customerDealerGroupList = [] } = data;
  // Deduplicate by groupId (the backend can return the same id as both a
  // number and a string) to avoid duplicate React keys in the menu.
  const uniqueGroups = [
    ...new Map(
      customerDealerGroupList.map(group => [`${group.groupId}`, group])
    ).values(),
  ];
  return [NO_GROUP_OPTION, ...uniqueGroups.map(mapGroupToOption)];
};

export const fetchCurrentDealerGroup = async dealerNumber => {
  if (!dealerNumber) {
    return null;
  }
  const { data } = await client.query({
    query: dealerListQuery,
    variables: { dealer_no: `${dealerNumber}`, limit: 1, page: FIRST_PAGE },
    // Read from the network so the dropdown preselects the dealer's current
    // group instead of a stale groupId cached by the dealer search/list.
    fetchPolicy: 'network-only',
  });
  const { customerDealerList = [] } = data;
  const currentDealer = customerDealerList.find(d => `${d.customerNumber}` === `${dealerNumber}`)
    || customerDealerList[0];
  const currentGroupId = currentDealer && currentDealer.groupId;
  if (currentGroupId == null || currentGroupId === '') {
    return null;
  }
  return {
    groupId: Number(currentGroupId),
    groupName: currentDealer.groupName || '',
  };
};
